import { z } from 'zod';
import { REMINDER_POLL_OPTION_MAX, REMINDER_POLL_OPTION_MIN, REMINDER_POLL_OPTION_TEXT_MAX, REMINDER_POLL_QUESTION_MAX, } from '@irl/types';
export const reminderPollSchema = z
    .object({
    question: z.string().trim().min(1).max(REMINDER_POLL_QUESTION_MAX),
    options: z
        .array(z.string().trim().min(1).max(REMINDER_POLL_OPTION_TEXT_MAX))
        .min(REMINDER_POLL_OPTION_MIN)
        .max(REMINDER_POLL_OPTION_MAX),
    isAnonymous: z.boolean(),
    allowsMultipleAnswers: z.boolean(),
    allowAddingOptions: z.boolean(),
})
    .superRefine((poll, ctx) => {
    if (new Set(poll.options.map((option) => option.toLocaleLowerCase('ru'))).size !==
        poll.options.length)
        ctx.addIssue({ code: 'custom', path: ['options'], message: 'Poll options must be unique' });
    if (poll.isAnonymous && poll.allowAddingOptions)
        ctx.addIssue({
            code: 'custom',
            path: ['isAnonymous'],
            message: 'Adding options requires a non-anonymous poll',
        });
});
//# sourceMappingURL=reminder-poll.js.map